/* eslint-disable @typescript-eslint/no-explicit-any */
import { useCallback } from "react";
import { useDataRef } from "./useDataRef";

export function useCallbackRef<Callback extends (...args: any) => any>(
  callback: Callback,
): Callback {
  const callbackRef = useDataRef(callback);

  return useCallback(
    ((...params) => callbackRef.current(...params)) as Callback,
    [callbackRef],
  );
}
